import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {COLORS} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {ReviewsSectionStream as PreviousReviewsImplementation} from '../PreviousReviewsImplementation/ReviewsSectionStream/ReviewsSectionStream';
import {useReviewsABTest} from '../utils/useReviewsABTest';
import {useUserReviewsTracking} from '../utils/useUserReviewsTracking';
import {ReviewsSectionStream} from './ReviewsSectionStream';

export interface Props {
  disableActionStatements?: boolean;
  disableUserReviews?: boolean;
}

export const ReviewsSectionView: FC<
  GetProductBulkResponse['reviewSection'] & Props
> = ({summary}) => {
  const {
    isABTestActive,
    isControlGroup,
    reviewsSectionRef,
    shouldShowUserReviews,
    shouldShowUserReviewsSlider,
    shouldShowPreviousReviewsImplementation,
    showQualityAndFitLabels,
    shouldAlignRightReviewsButton,
  } = useReviewsABTest();

  const {trackFeatureImpressionRef, handleAllReviewsButtonFeatureClick} =
    useUserReviewsTracking(summary);

  if (!isABTestActive || !summary) {
    return null;
  }

  if (isControlGroup) {
    return <div data-testid="reviewsSection-empty" ref={reviewsSectionRef} />;
  }

  return (
    <div
      ref={trackFeatureImpressionRef as React.RefObject<HTMLDivElement | null>}
    >
      {shouldShowPreviousReviewsImplementation ? (
        <Wrapper
          data-testid="oldReviewsSection"
          ref={reviewsSectionRef}
          disableBorderBottom
        >
          <PreviousReviewsImplementation
            summary={summary}
            disableActionStatements={shouldShowUserReviews}
            disableUserReviews={shouldShowUserReviewsSlider}
          />
        </Wrapper>
      ) : (
        <Wrapper data-testid="reviewsSection" ref={reviewsSectionRef}>
          <ReviewsSectionStream
            trackAllReviewsButtonFeatureClick={
              handleAllReviewsButtonFeatureClick
            }
            shouldShowUserReviews={shouldShowUserReviews}
            shouldShowUserReviewsSlider={shouldShowUserReviewsSlider}
            showQualityAndFitLabels={showQualityAndFitLabels}
            shouldAlignRightReviewsButton={shouldAlignRightReviewsButton}
            {...summary}
          />
        </Wrapper>
      )}
    </div>
  );
};

const Wrapper = styled.section<{disableBorderBottom?: boolean}>`
  ${({disableBorderBottom}) =>
    !disableBorderBottom &&
    css`
      border-bottom: 1px solid ${COLORS.Grey3};
    `}
  display: flex;
  flex-direction: column;
  padding: 0.8rem 1rem 0rem;
`;
